import React from "react";

export const MenuPortalContext = React.createContext<
  | HTMLElement
  | null
  | undefined
  | React.RefObject<HTMLElement | null | undefined>
>(undefined);

export const useMenuPortal = () => {
  const value: any = React.useContext(MenuPortalContext);
  return (value && "current" in value ? value.current : value) as
    | HTMLElement
    | null
    | undefined;
};
